import CycleRadioGroup from '@/components/service/cycle-radio-group';
import CategoryRadioGroup from '@/components/service/category-radio-group';
import CustomRadioGroup from '@/components/service/custom-radio-group';

export default {
  install(app) {
    app.component('CycleRadioGroup', CycleRadioGroup);
    app.component('CategoryRadioGroup', CategoryRadioGroup);
    app.component('CustomRadioGroup', CustomRadioGroup);
  }
}
